import React from 'react';

const WillKartPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2">
            <span className="text-2xl font-bold text-teal-600">PMS</span>
            <span className="text-2xl font-bold text-slate-800">Kart</span>
          </a>
          <a 
            href="/"
            className="text-sm text-teal-600 hover:text-teal-700 font-medium"
          >
            ← Back to Home
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">WillKart</h1>
          <p className="text-slate-600">Your AI-powered assistant</p>
        </div>

        {/* Iframe Container */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
          <iframe 
            src="https://willkart.ai/embed/c8381012-5c91-4e54-ae34-f1031c2a3b4b/client" 
            width="100%" 
            height="700" 
            style={{ border: 'none', borderRadius: '12px' }}
            allow="clipboard-write"
            title="WillKart AI Assistant"
          />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 mt-12 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} PMS Kart. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default WillKartPage;
